import {
  CampaignControllerCountCampaignsParams,
  CampaignControllerCountMembersParams,
  CampaignControllerDeleteCampaignParams,
  CampaignControllerDeleteMembersParams,
  CampaignControllerFindMembersToInviteParams,
  CampaignControllerGetCampaignParams,
  CampaignControllerGetTimelineParams,
  CampaignControllerListCampaingsParams,
  CampaignControllerListMembersParams,
  CreateCampaignDto,
  RestoreCampaignDto,
  SetCampaignFavoriteDto,
  SetCampaignVisibilityDto,
  UpdateCampaignAdditionalPermissionsDto,
  UpdateCampaignDto,
  CampaignControllerGetSimpleCampaignsListWithFoldersParams,
  ChangeCampaignOrderDto,
  RequestParams,
  CampaignControllerFindMemberGroupsToInviteParams,
  CampaignControllerGetAwDefaultSettingsParams,
  CopyCampaignDto,
  CampaignControllerGetSimpleCampaignsListParams
} from '@api/Api';
import { apiClient } from '@api/client';

export const createCampaign = (data: CreateCampaignDto) =>
  apiClient.campaign.campaignControllerCreateCampaign(data);

export const deleteCampaign = (
  params: CampaignControllerDeleteCampaignParams
) => apiClient.campaign.campaignControllerDeleteCampaign(params);

export const restoreDeletedCampaign = (data: RestoreCampaignDto) =>
  apiClient.campaign.campaignControllerRestoreDeletedCampaign(data);

export const setFavoriteCampaign = (data: SetCampaignFavoriteDto) =>
  apiClient.campaign.campaignControllerSetFavorite(data);

export const setCampaignVisibility = (data: SetCampaignVisibilityDto) =>
  apiClient.campaign.campaignControllerSetVisibility(data);

export const getCampaign = (params: CampaignControllerGetCampaignParams) =>
  apiClient.campaign.campaignControllerGetCampaign(params);

export const getCampaignList = (
  data: CampaignControllerListCampaingsParams,
  params: RequestParams = {}
) => apiClient.campaign.campaignControllerListCampaings(data, params);

export const getCampaignCount = (
  params: CampaignControllerCountCampaignsParams
) => apiClient.campaign.campaignControllerCountCampaigns(params);

export const getCampaignTimeline = (
  params: CampaignControllerGetTimelineParams
) => apiClient.campaign.campaignControllerGetTimeline(params);

export const updateCampaign = (data: UpdateCampaignDto) =>
  apiClient.campaign.campaignControllerUpdateCampaign(data);

export const getMembersList = (
  params: CampaignControllerListMembersParams,
  options?: RequestParams
) => apiClient.campaign.campaignControllerListMembers(params, options);

export const getMembersCount = (
  params: CampaignControllerCountMembersParams,
  options?: RequestParams
) => apiClient.campaign.campaignControllerCountMembers(params, options);

export const inviteMemberToCampaign = ({
  campaignId,
  memberIdsOrEmails,
  groupIds,
  message
}: {
  campaignId: string;
  memberIdsOrEmails?: string[];
  groupIds?: string[];
  message?: string;
}) => {
  const users = memberIdsOrEmails?.map((el) => ({
    memberIdOrEmail: el,
    customMessage: message
  }));
  const groups = groupIds?.map((id) => ({
    id,
    customMessage: message
  }));
  return apiClient.campaign.campaignControllerInviteCampaignMembers({
    campaignId,
    users,
    groups
  });
};

export const findCampaignMembersToInvite = (
  data: CampaignControllerFindMembersToInviteParams,
  params: RequestParams = {}
) => apiClient.campaign.campaignControllerFindMembersToInvite(data, params);

export const findCampaignMemberGroupsToInvite = (
  data: CampaignControllerFindMemberGroupsToInviteParams,
  params: RequestParams = {}
) =>
  apiClient.campaign.campaignControllerFindMemberGroupsToInvite(data, params);

export const deleteMemberFromCampaign = (
  params: CampaignControllerDeleteMembersParams
) => apiClient.campaign.campaignControllerDeleteMembers(params);

export const updateCampaignAdditionalPermissions = (
  params: UpdateCampaignAdditionalPermissionsDto
) => apiClient.campaign.campaignControllerUpdateAdditionalPermissions(params);

/** @deprecated Use separate queries for campaigns and folders instead */
export const campaignGetSimpleCampaignsListWithFolders = (
  params: CampaignControllerGetSimpleCampaignsListWithFoldersParams
) =>
  apiClient.campaign.campaignControllerGetSimpleCampaignsListWithFolders(
    params
  );

export const campaignGetSimpleCampaignsList = (
  params: CampaignControllerGetSimpleCampaignsListParams
) => apiClient.campaign.campaignControllerGetSimpleCampaignsList(params);

export const changeCampaignOrder = (data: ChangeCampaignOrderDto) =>
  apiClient.campaign.campaignControllerChangeCampaignOrder(data);

export const campaignGetAwDefaultSettings = (
  query: CampaignControllerGetAwDefaultSettingsParams,
  params: RequestParams = {}
) => apiClient.campaign.campaignControllerGetAwDefaultSettings(query, params);

export const campaignDuplicateCampaign = (data: CopyCampaignDto) =>
  apiClient.campaign.campaignControllerCopyCampaign(data);
